/*
 * Neukundenangebot – Gratis-Pflegelotion automatisch in den Warenkorb
 * -------------------------------------------------------------------
 * Legt die Pflegelotion automatisch in den Warenkorb, sobald
 *   (1) Shopify einen persönlichen Neukunden-Code im Warenkorb tatsächlich anwendet
 *       (Klaviyo-Coupon NEUKUNDE_20, Codes beginnen mit "Y", z. B. über den Mail-Link /discount/YXXXXXXXXXX) und
 *   (2) mindestens 3 Einzelpaare im Warenkorb liegen.
 * Entfernt die von diesem Skript hinzugefügte Lotion wieder, wenn eine der Bedingungen wegfällt
 * (z. B. wenn der Code nach 7 Tagen abgelaufen ist).
 * Gratis wird die Lotion durch den automatischen Shopify-Rabatt "Gratis Pflegelotion".
 * Die Liste der Einzelpaare muss mit den Produkten in "Gratis Pflegelotion" übereinstimmen.
 * Wichtig: Keine anderen Rabattcodes anlegen, die mit "Y" beginnen.
 */
(function () {
  'use strict';

  var CODE_PREFIX = 'Y';
  var GIFT_VARIANT_ID = 45134196736264; // Beinpflege SIGVARIS Leg Care Pflegelotion - 150ml
  var MIN_PAIRS = 3;
  var GIFT_PROPERTY = '_hallo20_geschenk';
  var ELIGIBLE_PRODUCT_IDS = [
    7521347961019, 7524986486971, 7524999299259, 8314559824136, 8314562281736,
    8314562543880, 8314562642184, 8314562937096, 8314564346120, 8314566082824,
    8315777384712, 8315778203912, 8315780563208, 8334428176648, 8353579794696,
    8405503475976, 8416643514632, 8416677265672, 8416696303880, 8434504401160,
    8434746360072, 8436657160456, 8437518237960, 8437545042184, 10495085084936,
    10763644043528, 12020868710664, 12168068268296, 12168087240968, 12168103788808,
    12168117158152, 12360595898632, // Tannengrün (ergänzt 01.11.2026)
    12360249999624, 12360244822280 // Breite Waden Bambus Grau, Baumwolle Weiß (ergänzt 01.11.2026)
  ];

  var busy = false;
  var timer = null;

  function codeFromCookie() {
    var match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!match) return [];
    return decodeURIComponent(match[1]).toUpperCase().split(',');
  }

  function isOfferCode(code) {
    return String(code || '').toUpperCase().indexOf(CODE_PREFIX) === 0;
  }

  // Persönlicher Neukunden-Code aus dem Mail-Link (Cookie), falls vorhanden
  function cookieOfferCode() {
    return codeFromCookie().filter(isOfferCode)[0] || null;
  }

  function codeEntry(cart) {
    if (!Array.isArray(cart.discount_codes)) return null;
    return cart.discount_codes.filter(function (c) {
      return isOfferCode(c.code);
    })[0] || null;
  }

  // Nur wenn Shopify den Neukunden-Code im Warenkorb tatsächlich anwendet (nicht nur eingetragen, nicht abgelaufen)
  function codeApplies(cart) {
    var entry = codeEntry(cart);
    return !!(entry && entry.applicable);
  }

  // Code aus dem Mail-Link einmal pro Sitzung in den Warenkorb übernehmen, falls er dort noch fehlt
  function shouldPushCode(cart) {
    if (codeEntry(cart) || !cookieOfferCode()) return false;
    if (Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0) return false;
    try { if (sessionStorage.getItem('neukunde_code_pushed')) return false; } catch (e) {}
    return true;
  }

  function pushCode() {
    try { sessionStorage.setItem('neukunde_code_pushed', '1'); } catch (e) {}
    var url = ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: cookieOfferCode(), sections: sectionIds() })
    }).then(function (r) { return r.json(); }).then(function (res) {
      render(res);
      scheduleCheck();
    });
  }

  function countPairs(cart) {
    return cart.items.reduce(function (sum, item) {
      return ELIGIBLE_PRODUCT_IDS.indexOf(item.product_id) > -1 ? sum + item.quantity : sum;
    }, 0);
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function requestConfig(body) {
    var config = typeof fetchConfig === 'function'
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = body;
    return config;
  }

  function sectionIds() {
    var drawer = getDrawer();
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function render(response) {
    var drawer = getDrawer();
    if (response && !response.status && drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(response);
    }
  }

  function addGift() {
    var form = new FormData();
    form.append('id', GIFT_VARIANT_ID);
    form.append('quantity', 1);
    form.append('properties[' + GIFT_PROPERTY + ']', '1');
    form.append('sections', sectionIds());
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(url, requestConfig(form)).then(function (r) { return r.json(); }).then(render);
  }

  function setGiftQuantity(lineKey, quantity) {
    var url = ((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity, sections: sectionIds() })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function check() {
    if (busy) { scheduleCheck(); return; }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (shouldPushCode(cart)) return pushCode();
        var qualifies = codeApplies(cart) && countPairs(cart) >= MIN_PAIRS;
        var giftLines = cart.items.filter(function (i) { return i.variant_id === GIFT_VARIANT_ID; });
        var ownLine = giftLines.filter(function (i) { return i.properties && i.properties[GIFT_PROPERTY]; })[0];

        if (qualifies && giftLines.length === 0) return addGift();
        if (!qualifies && ownLine) return setGiftQuantity(ownLine.key, 0);
        if (qualifies && ownLine && ownLine.quantity > 1) return setGiftQuantity(ownLine.key, 1);
      })
      .catch(function (e) { console.error('Neukunden-Geschenk:', e); })
      .then(function () { busy = false; });
  }

  function scheduleCheck() {
    clearTimeout(timer);
    timer = setTimeout(check, 250);
  }

  function init() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(function () {
        var Drawer = customElements.get('cart-drawer');
        if (!Drawer || Drawer.prototype.__hallo20) return;
        var originalOpen = Drawer.prototype.open;
        Drawer.prototype.open = function () {
          originalOpen.apply(this, arguments);
          scheduleCheck();
        };
        Drawer.prototype.__hallo20 = true;
      });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCheck);
    }
    // Beim Seitenaufruf nur prüfen, wenn ein Neukunden-Code über den Mail-Link aktiv ist (sonst kein Zusatzaufruf)
    if (cookieOfferCode()) scheduleCheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();